/** 可推导的Object.Entries */
export const ObjectEntries: <T extends Record<PropertyKey, unknown>>(object: T) => [keyof T, T[keyof T]][] =
  Object.entries;

/** 可推导的Object.keys */
export const ObjectKeys: <T extends Record<PropertyKey, unknown>>(object: T) => (keyof T)[] = Object.keys;

export const ObjectIn = <T extends Record<PropertyKey, unknown>>(obj: T, key: PropertyKey): key is keyof T => {
  return key in obj;
};
